import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './geneticTest.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class GeneticTestDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.geneticTest.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'geneticTest_' + this.props.geneticTest.testOrdered}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.geneticTest.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.geneticTest.testOrdered}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.testDate} />}
                value={this.props.geneticTest.testDate} language={this.props.language} isDate
                isActive={ this.configurationActive('TestDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.testSummary} />}
                value={this.props.geneticTest.testSummary} language={this.props.language}
                isActive={ this.configurationActive('TestSummary')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.testDetail} />}
                value={this.props.geneticTest.testDetail} language={this.props.language}
                isActive={ this.configurationActive('TestDetail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.patientCounseling} />}
                value={this.props.geneticTest.patientCounseling} language={this.props.language}
                isActive={ this.configurationActive('PatientCounseling')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.geneticTest.providerName} language={this.props.language}
                isActive={ this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.geneticTest.institution} language={this.props.language}
                isActive={ this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.geneticTest.providerPhone} language={this.props.language}
                isActive={ this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.geneticTest.providerEmail} language={this.props.language}
                isActive={ this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.geneticTest.comment} language={this.props.language}
                isActive={ this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="geneticTest_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.geneticTest.nullMessage}
        </div>
      </div>
    );
  }
}

GeneticTestDetail.propTypes = {
  geneticTest: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
